import React from 'react';
import { styled } from '../../themes';
import CategoryCard from '../category-card';
import { device } from 'themes/media-queries';
import { ROUTES } from 'navigation/route-map';

interface Category {
  title: string;
  shortDescription: string;
  image: string;
  isCompany?: boolean;
}

interface Props {
  categories: Category[];
}

const routeMap = {
  babysitting: ROUTES.BABYSITTING,
  gardening: ROUTES.GARDENING,
  'dog-minding': ROUTES.DOGMINDING,
  homework: ROUTES.HOMEWORK,
  event: ROUTES.EVENT,
};

const CategoryList = (props: Props) => {
  const { categories } = props;
  return (
    <Container>
      <List>
        {categories.map((category, i) => {
          return (
            <CategoryCard
              key={i}
              to={
                category.isCompany
                  ? 'https://business.yepstr.com'
                  : routeMap[category.slug]
              }
              title={category.title}
              text={category.shortDescription}
              image={category.image}
              isCompany={category.isCompany}
            />
          );
        })}
      </List>
    </Container>
  );
};

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  max-width: 100%;
`;

const List = styled.div`
  display: grid;
  grid-gap: 2.5rem;
  grid-template-columns: repeat(3, minmax(30rem, 40rem));
  grid-template-rows: 1fr;
  grid-auto-rows: 1fr;
  align-items: start;
  overflow: visible;

  @media ${device.laptopL} {
    grid-template-columns: repeat(2, minmax(30rem, 40rem));
  }

  @media ${device.mobileL} {
    grid-gap: 1rem;
    grid-template-columns: repeat(6, minmax(35rem, 40rem));
    overflow-x: scroll;
    padding: 3rem;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
  }
`;

export default CategoryList;
